import React, { Component } from 'react';
import Select from 'react-select'
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';

import { isEmpty } from 'lodash';
import Photos from '../../../../commonModules/interface/input-files.jsx';
import { Box, Button } from '@material-ui/core';
import { SingleSwitch } from '../../../../commonModules/MUI/RadioAndCheckbox.jsx';
import InputFactID from './InputFactID.jsx';

class FormPurchase extends Component {
    state = {
    }
    createShopList = () => {
        const {SHOPS, purchase} = this.props
        let list = [{value:"", label:"Chosissez un Magasin"}]
        if( !isEmpty(SHOPS) ){// select shop options in Form
            Object.values(SHOPS).forEach( shop => { 
                list.push ({
                    value:shop.id, 
                    label:shop.name, 
                    disabled: (purchase.shop === shop.id || !!shop.shop_disabled)
                })
            })
        }
        return list
    }

    // checkFactID = () => {
    //     const { fact_id_5000 } = this.props.purchase;
    //     let factExist = {}
    //     let config = {
    //         headers: {
    //             'Content-Type': 'application/json',
    //             //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
    //         }
    //     }
    //     fact_id_5000.split(",").forEach( async spendingID => {
    //         console.log({spendingID});
    //         if (!factExist[spendingID]) {
    //             const res = await Axios.post("/stocks/compta/spendings/single", {spendingID}, config)
    //             console.log({res});
    //             if (res.data && res.data.spending_id != "") {
    //                 factExist[spendingID] = res.data
    //             }
    //         }
    //         console.log("checkFactID", {factExist});
    //         this.setState({
    //             factExist,
    //         })
    //     })
    //     this.setState({
    //         showFactures : true
    //     })
    // }
    render() {
        const {showFactures, spendingID, factExist} = this.state;
        console.log("[PROPS PURCHASE]", this.props.purchase)
        console.log({factExist});
        return (
            <Box className="card-text">
                <h4 className="card-title">Nouvel Achat</h4>
                <Box p={2}>
                    {/* {this.props.arrivage &&
                        <Grid item xs={12}>
                            <InputText
                                value={this.props.SHOPS[this.props.purchase.shop_id].name || ""}
                                error={this.props.errors.shop_id}
                                label="Magasin"
                            /> 
                        </Grid>
                    } */}
                    <InputSelectMagasin
                        label="Magasin"
                        options={this.createShopList()}
                        value={this.props.purchase.shopDisplay}
                        onChange={ option => this.props.handleSelect(option, "shop")}
                        error={this.props.errors.shop}
                    />
                    {/* <InputText 
                        type="text" 
                        id="fact_id_5000" 
                        onChange={this.props.handleChange} 
                        value={this.props.purchase.fact_id_5000} 
                        name="fact_id_5000" 
                        title="N° Facture 5000"
                        helperText="Si plusieurs: séparer par une virgule sans espaces (12334,23455,45645...) "
                        error={this.props.errors.fact_id_5000}
                        rows={3}
                    />
                    { this.props.purchase.fact_id_5000 &&
                        <IconButton onClick={this.checkFactID} color="secondary">
                            <Visibility />
                        </IconButton>
                    } */}
                    {/* <InputFactID 
                        id="fact_id_5000" 
                        handleChange={this.props.handleChange} 
                        fact_id_5000={this.props.purchase.fact_id_5000} 
                        name="fact_id_5000" 
                        error={this.props.errors.fact_id_5000}
                    /> */}
                    <FormLayout 
                        {...this.props} 
                        title={"Produits"}
                        createAddForm={this.props.createAddForm}
                        onClick={this.props.handleAddProd}
                        onClickForCSVUpload={this.props.handleAddProdByCSV}
                        colSpan={4}
                    />                        
                
                    {/* <FormControl component="fieldset">

                        <FormGroup aria-label="position" row>
                            <FormControlLabel
                                // value="start"
                                control={<Checkbox color="primary" />}
                                label="Commande reçue"
                                labelPlacement="start"
                                name="received" 
                                checked={this.props.purchase.received} 
                                onChange={
                                    (e) => this.props.handleCheck(e.target.checked)
                                }
                            />
                        </FormGroup>
                    </FormControl> */}
                    {/* <Box>
                        <SingleSwitch
                            color="primary"
                            label="Commande reçue"
                            labelPlacement="start"
                            name="received" 
                            checked={this.props.purchase.received} 
                            onChange={
                                (e) => this.props.handleCheck(e.target.checked, "received")
                            }
                        />
                    </Box> */}
                    <Box>
                        <SingleSwitch
                            color="primary"
                            label="Importé"
                            labelPlacement="start"
                            name="is_imported" 
                            checked={this.props.purchase.is_imported} 
                            onChange={
                                (e) => this.props.handleCheck(e.target.checked, "is_imported")
                            }
                        />
                    </Box>
                    
                    <Box p={1}>
                        {/* <label htmlFor="transfer_files" className="control-label">Documents</label> */}
                        {/* <Photos
                            photoList={this.props.setFiles} 
                            photos={this.props.purchase.transfer_files === null ? [] : this.props.purchase.transfer_files } 
                            file 
                        /> */}
                        <Photos
                            saved={this.props.purchase ? this.props.purchase.transfer_files : null}
                            id="transfer_files_req"
                            photoList={this.props.setFiles} 
                            photos={this.props.purchase.transfer_files_req === null ? [] : this.props.purchase.transfer_files_req } 
                            file 
                        />
                    </Box>
                    <InputText 
                        type="text" 
                        id="comments"
                        value={this.props.purchase.comments} 
                        name="comments" 
                        onChange={this.props.handleChange}
                        title="Remarques"
                        multi
                        rows={2}
                    />

                    <InputText 
                        type="number" 
                        step="0.01"
                        id="transport" 
                        onChange={this.props.handleChange} 
                        value={this.props.purchase.transport} 
                        name="transport" 
                        title="Coût Transport"
                        error={this.props.errors.transport}
                    />
                    
                    <InputText 
                        type="number" 
                        step="0.01"
                        id="taxes"
                        onChange={this.props.handleChange} 
                        value={this.props.purchase.taxes} 
                        onBlur={this.props.total} 
                        name="taxes" 
                        title="Autre taxes"
                        error={this.props.errors.taxes}
                    />
                                    
                    <InputText 
                        type="text" 
                        disabled 
                        id="total"
                        value={this.props.purchase.total} 
                        name="total" 
                        onChange={this.props.handleChange}
                        title="Coût Total"
                    />
                        
                    <Box p={2}>
                        <Button 
                            color="secondary"
                            variant="contained"
                            className="confirm"
                            onClick={ this.props.handleSubmit }
                        >
                            Valider
                        </Button>
                        <Button 
                            color="secondary"
                            onClick={this.props.handleClose}
                        >
                            Annuler
                        </Button>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default FormPurchase;
